"use client";

import { useId } from "react";
import { CloseIconButton } from "../close-icon-button";
import styles from "./DrawerHeader.module.scss";
import type { ReactNode } from "react";

export type DrawerHeaderProps = {
  /** Drawer title (plain string becomes an `h2` with id for `aria-labelledby` on the dialog). */
  title: ReactNode;
  onClose: () => void;
  subtitle?: ReactNode;
  /** Optional actions between title and close (e.g. external link). */
  actions?: ReactNode;
  /** Disable close (e.g. while submitting). */
  closeDisabled?: boolean;
};

export const DrawerHeader = ({ title, subtitle, onClose, actions, closeDisabled }: DrawerHeaderProps) => {
  const titleId = useId();
  const showStringTitle = typeof title === "string";

  return (
    <header className={styles["comp"]}>
      <div className={styles["comp__text"]}>
        {showStringTitle ? (
          <h2 className={styles["comp__title"]} id={titleId}>
            {title}
          </h2>
        ) : (
          title
        )}
        {subtitle != null ? (
          typeof subtitle === "string" ? (
            <p className={styles["comp__subtitle"]}>{subtitle}</p>
          ) : (
            subtitle
          )
        ) : null}
      </div>
      {actions != null ? <div className={styles["comp__actions"]}>{actions}</div> : null}
      <CloseIconButton onClick={onClose} disabled={closeDisabled} aria-label="Close" />
    </header>
  );
};
